import { formatSystemValue } from './payRunsModel';

const INVALID_ROUTE = 'approval_route_missing_configuration_identity';

export const readinessBlockerMessage = (reason: string): string =>
  reason === INVALID_ROUTE
    ? 'This Pay Group has no valid approval route. Configure or correct its approval route, including EFT and super approvers, then run readiness evaluation again.'
    : `Readiness is blocked: ${formatSystemValue(reason)}.`;

export const readinessReviewDetail = (reason: string): string =>
  reason === INVALID_ROUTE ? 'Valid approval route required' : 'Readiness blocked';
